export default () => {
    let el = document.getElementById('player-component__video')
    let text = document.getElementById('player-component__text')
    let button = document.getElementById('player-component__button')
    button.style.display = 'block'

    el.pause()
    el.currentTime = 0
    if(text) {
        text.style.animation = 'none'
    }
    document.documentElement.style.setProperty('--textMargin', `calc(var(--widthVideo) + var(--widthVideo) / 2)`)
}